import React, { CSSProperties } from 'react';
import Skeleton from 'react-loading-skeleton';

export type LoadingSkeletonProps = {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  borderRadius?: CSSProperties['borderRadius'];
  count?: number;
  className?: string;
  'data-testid'?: string;
};

export const LoadingSkeleton = ({
  width,
  height,

  borderRadius,
  count,
  className,
  'data-testid': dataTestId,
}: LoadingSkeletonProps) => {
  return (
    <Skeleton
      width={width}
      height={height}
      borderRadius={borderRadius}
      count={count}
      containerTestId={dataTestId}
      containerClassName={className}
    />
  );
};
